


























import {Component, Vue} from 'vue-property-decorator';

@Component
export default class Assistance extends Vue {
  returnHome(): void {
    this.$router.back();
  }
}
